import {
  createCatalogImport as publicCreateCatalogImport,
  addProductsToImport as publicAddProductsToImport,
  submitCatalogImport as publicSubmitCatalogImport,
} from './stores-catalog-v3-catalog-import-catalog-imports-v-3.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createCatalogImport: MaybeContext<
  BuildRESTFunction<typeof publicCreateCatalogImport> &
    typeof publicCreateCatalogImport
> = /*#__PURE__*/ createRESTModule(publicCreateCatalogImport);
export const addProductsToImport: MaybeContext<
  BuildRESTFunction<typeof publicAddProductsToImport> &
    typeof publicAddProductsToImport
> = /*#__PURE__*/ createRESTModule(publicAddProductsToImport);
export const submitCatalogImport: MaybeContext<
  BuildRESTFunction<typeof publicSubmitCatalogImport> &
    typeof publicSubmitCatalogImport
> = /*#__PURE__*/ createRESTModule(publicSubmitCatalogImport);

export {
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  Type,
  EntranceEffectType,
  LoopEffectType,
  PointerEffectType,
  TextAlignment,
  LineCap,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Variant,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  LayoutDataBackgroundType,
  Origin,
  BannerPosition,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  MediaType,
  ProductOptionRenderType,
  ChoiceType,
  ModifierRenderType,
  ProductType,
  MeasurementUnit,
  WeightUnit,
  DimensionsUnit,
  FileType,
  SubscriptionFrequency,
  DiscountType,
  UserCriteria,
  SortOrder,
  WebhookIdentityType,
} from './stores-catalog-v3-catalog-import-catalog-imports-v-3.universal.js';
export {
  CatalogImport,
  CreateCatalogImportRequest,
  CreateCatalogImportResponse,
  AddProductsToImportRequest,
  ProductItem,
  ProductWithInventory,
  ProductWithInventoryTypedPropertiesOneOf,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  Animation,
  EntranceAnimation,
  EntranceEffect,
  LoopAnimation,
  LoopEffect,
  PointerEffect,
  CodeBlockData,
  TextStyle,
  DividerData,
  DividerDataStyles,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  V1Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  ImageDataCrop,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  SketchData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  TableDataDimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackground,
  LayoutDataBackgroundImage,
  Banner,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  CheckboxListData,
  ListItemNodeData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  Media,
  ProductMedia,
  ProductMediaSetByOneOf,
  ProductMediaMediaOneOf,
  VideoResolution,
  Thumbnail,
  MediaItemsInfo,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  ConnectedOption,
  ConnectedOptionOptionSettingsOneOf,
  ChoicesSettings,
  ConnectedOptionChoice,
  ConnectedOptionChoiceValueOneOf,
  MultipleColors,
  MediaReferences,
  MediaReference,
  MediaReferenceIdentifierOneOf,
  ConnectedModifier,
  ConnectedModifierModifierSettingsOneOf,
  FreeTextSettings,
  ModifierChoicesSettings,
  ConnectedModifierChoice,
  ConnectedModifierChoiceValueOneOf,
  Brand,
  InfoSection,
  Ribbon,
  PhysicalProperties,
  PricePerUnitSettings,
  WeightRange,
  PricePerUnitRange,
  PricePerUnitRangePricePerUnit,
  WeightMeasurementUnitInfo,
  VariantsInfo,
  VariantWithInventory,
  VariantWithInventoryTypedPropertiesOneOf,
  PriceInfo,
  FixedMonetaryAmount,
  RevenueDetails,
  VariantPhysicalProperties,
  PricePerUnit,
  Dimensions,
  VariantDigitalProperties,
  SecuredMedia,
  InventoryItemComposite,
  InventoryItemCompositeTrackingMethodOneOf,
  PreorderInfo,
  OptionChoiceReferences,
  OptionChoiceIds,
  OptionChoiceNames,
  SubscriptionDetails,
  Subscription,
  SubscriptionCyclesOneOf,
  SubscriptionDiscount,
  SubscriptionDiscountDiscountOneOf,
  PurchaseEligibility,
  ExtendedFields,
  Tags,
  TagList,
  ProductCategoryIdsInfo,
  AddProductsToImportResponse,
  AddProductResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  SubmitCatalogImportRequest,
  SubmitCatalogImportResponse,
  CatalogImportAlreadySubmittedErrorData,
  QueryProductItemsInImportRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryProductItemsInImportResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
} from './stores-catalog-v3-catalog-import-catalog-imports-v-3.universal.js';
export {
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TypeWithLiterals,
  EntranceEffectTypeWithLiterals,
  LoopEffectTypeWithLiterals,
  PointerEffectTypeWithLiterals,
  TextAlignmentWithLiterals,
  LineCapWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  VariantWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  OriginWithLiterals,
  BannerPositionWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  MediaTypeWithLiterals,
  ProductOptionRenderTypeWithLiterals,
  ChoiceTypeWithLiterals,
  ModifierRenderTypeWithLiterals,
  ProductTypeWithLiterals,
  MeasurementUnitWithLiterals,
  WeightUnitWithLiterals,
  DimensionsUnitWithLiterals,
  FileTypeWithLiterals,
  SubscriptionFrequencyWithLiterals,
  DiscountTypeWithLiterals,
  UserCriteriaWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SubmitCatalogImportApplicationErrors,
} from './stores-catalog-v3-catalog-import-catalog-imports-v-3.universal.js';
